export const COMMENT_MENTION_LINK_PREFIX = '#beam-mention:';

export const COMMENT_MENTION_CLASSNAME =
  'beam-comment-mention inline rounded-[5px] bg-purple100 px-1 py-px font-semibold text-purple300 no-underline';

export const isCommentMentionLink = (href?: string) =>
  Boolean(href?.startsWith(COMMENT_MENTION_LINK_PREFIX));

export const getCommentMentionUserId = (href?: string) => {
  if (!isCommentMentionLink(href)) return '';

  try {
    return decodeURIComponent(
      String(href).slice(COMMENT_MENTION_LINK_PREFIX.length),
    );
  } catch {
    return '';
  }
};
